import { render, staticRenderFns } from "./searchMajorDialog.vue?vue&type=template&id=64a6a30f"
import script from "./searchMajorDialog.vue?vue&type=script&lang=js"
export * from "./searchMajorDialog.vue?vue&type=script&lang=js"
import style0 from "./searchMajorDialog.vue?vue&type=style&index=0&id=64a6a30f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports